import React from 'react';

const Materials = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13H7V17H1V13Z" stroke="#FF4D3A" strokeWidth="2"/>
            <path d="M5 9H14V13H5L5 9Z" stroke="#FF4D3A" strokeWidth="2"/>
            <path d="M5 1H14V5H5L5 1Z" stroke="#FF4D3A" strokeWidth="2"/>
            <path d="M7 13H17V17H7L7 13Z" stroke="#FF4D3A" strokeWidth="2"/>
            <path d="M11 5H17V9H11V5Z" stroke="#FF4D3A" strokeWidth="2"/>
            <path d="M1 5H11V9H1L1 5Z" stroke="#FF4D3A" strokeWidth="2"/>
        </svg>
    )
}

export default Materials;